export enum CheckpointStatusEnum {
    COMPLETED = 'COMPLETED',
    CURRENT = 'CURRENT',
    PENDING = 'PENDING',
    UNKNOWN = 'UNKNOWN',
}
